import { v1 as uuidv1 } from 'uuid';

export const SESSION_KEY = uuidv1();
